module.exports = __webpack_public_path__ + "static/img/witness-kids-5.14720cef.png";